import { createAction, props } from '@ngrx/store';
import { iFormasEnvio } from '../../entrada/entrada.interface';

export const cargaFormasEnvio = createAction('[FormasEnvio Component] cargaFormasEnvio', props<{ oFormasEnvio: iFormasEnvio[] }>());
export const resetFormasEnvio = createAction('[FormasEnvio Component] resetFormasEnvio');
